import * as types from './actionTypes';
import discussionService from '../services/discussionService';
import { fetch, addTask } from 'domain-task';
import moment from 'moment';

export function getSections() {
    return (dispatch, getState) => {
        const existingSections = getState().discussions.sections;
        if(existingSections.length === 0) {        
            let fetchTask = discussionService.getDiscussionSections()
                .then(sections => {
                    if(sections) {
                        dispatch({ type: types.GET_DISCUSSION_SECTIONS, sections });
                    }
                    return sections;
                })
                .catch(error => {
                    throw(error)
                });
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return new Promise((resolve, reject) => resolve(existingSections));
        }
    };
}

export function getDiscussions(sectionLink, page, forceReload = false) {
    //add a force reload flag?
    return (dispatch, getState) => {
        //make sure we have the sections first, this call will just return the existing sections if we do
        debugger;
        let fetchTask = getSections()(dispatch, getState)
            .then(_ => {
                //we should have the sections by now
                const section = getState().discussions.sections.find(s => s.Link === sectionLink)
                if(section) {
                    const existingDiscussions = section.discussions;
                    debugger;
                    //also check if the page is different to the requested page or the data is stale
                    if(forceReload || !existingDiscussions || existingDiscussions.Page !== page || new Date(existingDiscussions.lastLoaded) < moment().subtract(1, 'minutes')) {        
                        dispatch({ type: types.CLEAR_DISCUSSIONS, sectionLink });
                        return discussionService.getDiscussions(sectionLink, page)
                            .then(discussions => {
                                if(discussions) {
                                    discussions.lastLoaded = new Date()
                                    dispatch({ type: types.GET_DISCUSSIONS, payload: {sectionLink, discussions} });
                                }
                                return discussions;
                            })
                            .catch(error => {
                                throw error;
                            });
                    }
                    else {
                        return new Promise((resolve, reject) => resolve(existingDiscussions));
                    }
                }
                else {
                    //the sectionLink is wrong, return nothing
                    return new Promise((resolve, reject) => resolve(null));
                }
            });
        
        addTask(fetchTask);
        return fetchTask;
    };
}

export function getPosts(sectionLink, discussionLink, page, currentProfileID, forceReload = false) {
    //add a force reload flag?
    return (dispatch, getState) => {
        const currentDiscussion = getState().discussions.currentDiscussion;
        //also check if the page is different to the requested page or the data is stale
        const dateMinus1Minute = moment().subtract(1, 'minutes');
        const needReload = forceReload || !currentDiscussion || currentDiscussion.Section.Link !== sectionLink || currentDiscussion.Discussion.Link !== discussionLink || currentDiscussion.Posts.Page !== page || new Date(currentDiscussion.lastLoaded) < dateMinus1Minute; 
        if(needReload || currentDiscussion.requestedBy !== currentProfileID) {        
            if(needReload || currentDiscussion.requestedBy) {
                /* we want to avoid clearing any existing posts (and showing the loading icon) if we loaded from the server and then are 
                reloading for the logged-in user as we'll get a flash of server data followed by the loading icon. In this case, all the 
                criteria but the requested by will be true and the requestedBy will be null as the server doesn't have the user data
                so we're separating the checks */
                dispatch({ type: types.CLEAR_POSTS });
            }
            let fetchTask = discussionService.getPosts(sectionLink, discussionLink, page, currentProfileID)
                .then(currentDiscussion => {
                    if(currentDiscussion) {
                        currentDiscussion.lastLoaded = new Date()
                        currentDiscussion.requestedBy = currentProfileID;
                        dispatch({ type: types.GET_POSTS, currentDiscussion });
                    }
                    return currentDiscussion;
                })
                .catch(error => {
                    throw error;
                });
            addTask(fetchTask);
            return fetchTask;        
        }
        else {
            return new Promise((resolve, reject) => resolve(currentDiscussion));
        };        
    };
}

export function addDiscussion(sectionLink, newDiscussion){
    return function(dispatch) {
        return discussionService.addDiscussion(sectionLink, newDiscussion).then(discussion => {  
            return discussion;
        }).catch(error => {
            throw error;
        });
    };
}

export function addPost(sectionLink, discussionLink, newPost){
    return function(dispatch) {
        return discussionService.addPost(sectionLink, discussionLink, newPost).then(post => {  
            return post;
        }).catch(error => {
            throw error;
        });
    };
}

export function reportPost(postID, reportType, currentProfileID){
    return function(dispatch) {
        return discussionService.reportPost(postID, reportType, currentProfileID).then(result => {  
            //we're expecting a no content here
            dispatch({ type: types.UPDATE_POST_REPORT, payload: { postID, reported: true } });
            return result;
        }).catch(error => {
            throw error;
        });
    };
}

export function deleteReportPost(postID, currentProfileID){
    return function(dispatch) {
        return discussionService.deleteReportPost(postID, currentProfileID).then(result => {  
            //we're expecting a no content here
            dispatch({ type: types.UPDATE_POST_REPORT, payload: { postID, reported: false } });
            return result;
        }).catch(error => {
            throw error;
        });
    };
}